import { render, staticRenderFns } from "./myRobotAPI.vue?vue&type=template&id=98971fb6&"
import script from "./myRobotAPI.vue?vue&type=script&lang=js&"
export * from "./myRobotAPI.vue?vue&type=script&lang=js&"
import style0 from "./myRobotAPI.vue?vue&type=style&index=0&id=98971fb6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports